import { FontWeights } from "./FontWeights";

export const TypographyVariant = (color: string) =>
  ({
    h1: {
      fontWeight: FontWeights.semiBold,
      fontSize: "3.75rem",
      lineHeight: "4.5rem",
      letterSpacing: "-0.02em",
      color,
    },
    h2: {
      fontWeight: FontWeights.semiBold,
      fontSize: "3rem",
      lineHeight: "3.5rem",
      letterSpacing: "-0.02em",
      color,
    },
    h3: {
      fontWeight: FontWeights.semiBold,
      fontSize: "2 rem",
      lineHeight: "2.5 rem",
      letterSpacing: "-0.02 em",
      color,
    },
    h4: {
      fontWeight: FontWeights.semiBold,
      fontSize: "1.75rem",
      lineHeight: "2.25rem",
      letterSpacing: "-0.02em",
      color,
    },
    h5: {
      fontWeight: FontWeights.semiBold,
      fontSize: "1.5 rem",
      lineHeight: "2 rem",
      letterSpacing: "-0.02 em",
      color,
    },
    h6: {
      fontWeight: FontWeights.semiBold,
      fontSize: "1.25rem",
      lineHeight: "1.75rem",
      letterSpacing: "-0.02em",
      color,
    },
    subtitle1: {
      fontWeight: FontWeights.regular,
      fontSize: "1.125rem",
      lineHeight: "1.625rem",
      letterSpacing: "-0.02em",
      color,
    },
    body1: {
      fontWeight: FontWeights.regular,
      fontSize: "1rem",
      lineHeight: "1.5rem",
      letterSpacing: "0em",
      color,
    },
    body2: {
      fontWeight: FontWeights.regular,
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      letterSpacing: "0em",
      color,
    },
    body3: {
      fontWeight: FontWeights.regular,
      fontSize: "0.75rem",
      lineHeight: "1rem",
      letterSpacing: "0.01em",
      color,
    },
    overline: {
      fontWeight: FontWeights.semiBold,
      fontSize: "0.688rem",
      lineHeight: "0.75rem",
      letterSpacing: "0.01em",
      textTransform: "uppercase",
      color,
    },
  }) as const;

export type Typography = typeof TypographyVariant;
